import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
import { PACK_CHAT_STATUS } from "@/payroll/pack-chat/types";

export const THREAD_FILTER = {
  all: "all",
  open: PACK_CHAT_STATUS.open,
  closed: PACK_CHAT_STATUS.closed,
} as const;

export type ThreadFilter = (typeof THREAD_FILTER)[keyof typeof THREAD_FILTER];

const FILTER_LABELS: Record<ThreadFilter, string> = {
  [THREAD_FILTER.all]: "All",
  [THREAD_FILTER.open]: "Open",
  [THREAD_FILTER.closed]: "Closed",
};

export const PackChatThreadFilter = ({
  value,
  counts,
  onChange,
}: {
  value: ThreadFilter;
  counts: Record<ThreadFilter, number>;
  onChange: (next: ThreadFilter) => void;
}) => (
  <Stack
    direction="row"
    align="center"
    gap="md"
    className="w-full"
    role="group"
    aria-label="Filter threads by status"
  >
    {Object.values(THREAD_FILTER).map((filter) => (
      <button
        key={filter}
        type="button"
        aria-pressed={value === filter}
        onClick={() => onChange(filter)}
        className={cn("text-[13px] transition-colors", {
          "font-semibold text-primary-text": value === filter,
          "text-tertiary-text hover:text-secondary-text": value !== filter,
        })}
      >
        {FILTER_LABELS[filter]}
        <span
          className={cn("ml-1", {
            "text-secondary-text": value === filter,
            "text-tertiary-text": value !== filter,
          })}
        >
          {counts[filter]}
        </span>
      </button>
    ))}
  </Stack>
);
